export enum UserStatusEnum {
  ENABLED = 0,
  DISABLED = 1,
}

export type User = {
  isLogin: boolean;
  phone?: string;
  disableFlag?: UserStatusEnum;
  msg?: string;
};

export type UseAuthType = {
  user: User | null;
  login: () => void;
  logout: () => void;
};
